<template>
<!-- almost copy-pasted from `Authentication.vue`. -->
<form class="quick-form order-confirmation-stage" @submit.prevent="confirmOrder">
  <div class="quick-form__icon">
    <IconSms/>
  </div>
  <h2 class="quick-form__title">Введите SMS-код</h2>
  <p class="quick-form__subtitle">Мы отправили SMS-код на ваш номер<br>{{ phone }}</p>
  <SmsCodeInput
    v-model="form.code"
    @input="e => { if (e.length === 4) { confirmOrder(); } }"
    class="order-confirmation-stage__code"
  />
  <span class="quick-form__error" :class="{ invisible: !errors.code }">
    {{ errors.code ? errors.code : 'just so it takes vertical space' }}
  </span>
  <button
    type="submit"
    class="btn btn-primary btn-sm btn-block btn-rounded quick-form__max-width-block"
    :disabled="orderIsConfirming"
  >
    <i class="fal fa-spinner fa-spin" v-if="orderIsConfirming"></i>
    Подтвердить
  </button>
  <button
    v-if="spamTimeout <= 0"
    @click="() => { form.code = ''; resendCode(); }"
    type="button"
    class="quick-form__text-button"
  >
    Выслать код повторно
  </button>
  <SmsCooldownText v-else :value="spamTimeout"/>
</form>
</template>

<script>
import axios from '@/zenky'
import SmsCodeInput from '@/components/inputs/SmsCodeInput';
import SmsCooldownText from '@/components/SmsCooldownText.vue';
import setCooldownTimer from '@/helpers/setCooldownTimer'
import { getCooldownTime } from '@/helpers/apiErrors'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    SmsCodeInput,
    SmsCooldownText,
    IconSms: () => import(/* webpackPreload: true */ '@/assets/images/icons/icon-sms.svg?inline'),
  },

  props: {
    phone: {
      type: String,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    }
  },

  computed: {
    ...mapGetters({
      order: 'order/order',
    }),

    pluralize() { return pluralize; }
  },

  methods: {
    ...mapActions({
      confirm: 'order/confirmOrder',
      initUserFromToken: 'auth/initUserFromToken',
    }),

    confirmOrder() {
      if (this.orderIsConfirming) {
        return
      } else if (!parseInt(this.form.code, 10)) {
        return this.errors.code = 'Пожалуйста, укажите код из SMS.'
      }

      this.errors.code = ''
      this.orderIsConfirming = true

      this.confirm(parseInt(this.form.code, 10))
        .then(data => {
          if (data && data.token) {
            this.initUserFromToken(data.token)
          }

          this.orderIsConfirming = false
          this.$emit('completed')
        })
        .catch(() => {
          this.orderIsConfirming = false
          this.errors.code = 'Вы указали неправильный код.'
        })
    },

    async resendCode() {
      const req = axios.request({
        method: 'POST',
        url: `orders/${this.orderId}/confirm/resend`,
        params: { token: this.order.token },
      });

      await req;
    }
  },

  data() {
    return {
      form: {
        code: '',
      },
      errors: {
        code: '',
      },
      spamTimeout: 0, // TODO can it be already there, e.g. as soon as the order was submitted?
      spamTimeoutDecIntervalId: -1,
      orderIsConfirming: false,
    }
  }
}
</script>

<style lang="less">
@import '~@/assets/less/components/quick-form';
</style>
